import React from 'react';
import PropTypes from 'prop-types';

import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

const mapStyle = {
    marginTop: "5px",
    width: "100%",
    height: "469px"
}

const StaticMap = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyC6oQCEcKbgMQ38_EoiudIgZ413ugM1WmA&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={mapStyle} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(({ zoom, center }) => {
    return (
        <GoogleMap
            zoom={zoom}
            center={center}
            options={
                {
                    styles: [
                        {
                            featureType: 'poi.business',
                            stylers: [{ visibility: 'off' }]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.icon',
                            stylers: [{ visibility: 'off' }]
                        }
                    ]
                }
            }>
            < Marker
                position={{ lat: center.lat, lng: center.lng }}
            />
        </GoogleMap>
    )
});

StaticMap.propTypes = {
    zoom: PropTypes.number,
    center: PropTypes.any,

};

export default StaticMap;



// WEBPACK FOOTER //
// ./src/components/blocks/StaticMap/StaticMap.js